import React from 'react'
import { ArrowLeft, Settings } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import CdnSwitcher from '../components/CdnSwitcher'

const SettingsPage: React.FC = () => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate(-1)
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center mb-6">
        <button
          onClick={handleBackClick}
          className="flex items-center text-blue-600 hover:text-blue-700 mr-4"
        >
          <ArrowLeft className="w-5 h-5 mr-1" />
          返回
        </button>
        <h1 className="text-2xl font-bold text-gray-900 flex items-center">
          <Settings className="w-6 h-6 mr-2" />
          系统设置
        </h1>
      </div>

      <div className="max-w-4xl mx-auto space-y-6">
        {/* CDN切换控制 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">CDN配置</h2>
          <CdnSwitcher />
        </div>

        {/* 其他设置可以在这里添加 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">其他设置</h2>
          <div className="bg-white rounded-lg shadow p-4">
            <div className="text-gray-500 text-center py-8">
              更多设置功能开发中...
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SettingsPage 